<mat-toolbar class="no-print" fxLayoutGap="8px" fxLayoutAlign="center center">
  <button mat-button (click)="navigatedTop()" style="padding-left: 14px;">
    <mat-icon>apartment</mat-icon>
    <span>{{'施設管理' | translate}}</span><span *ngIf="projectName">［{{projectName}}］</span>
  </button>

  <div class="header-menu" fxLayout="row" fxLayoutGap="5px">
    <button  mat-button *ngIf="!!isSignIn && (userType === USER_TYPE_ADMIN || userType === USER_TYPE_MASTER) && !projectId" [routerLink]="[userLink]">{{'ユーザー' | translate}}</button>
    <button  mat-button *ngIf="!!isSignIn && userType === USER_TYPE_ADMIN  && !projectId" [routerLink]="[generalTextLink]">{{'汎用テキスト' | translate}}</button>
    <button  mat-button *ngIf="!!isSignIn && userType === USER_TYPE_ADMIN  && !projectId" [routerLink]="[languageLink]">{{'言語' | translate}}</button>
    <button  mat-button *ngIf="!!isSignIn && userType === USER_TYPE_ADMIN  && !projectId" [routerLink]="[noticeManageLink]">{{'通知管理' | translate}}</button>
    <button  mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !projectId" [routerLink]="[boardThreadLink]">{{'掲示板' | translate}}</button>

    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId"
      [matMenuTriggerFor]="project">{{'プロジェクト' | translate}}</button>
    <mat-menu #project="matMenu">
      <button mat-menu-item [routerLink]="[projectLink]">{{'プロジェクト情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[uploaderLink]">{{'ファイルアップロード' | translate}}</button>
      <button mat-menu-item [routerLink]="[uploaderDLLink]">{{'ファイルアップロード(プレゼント用)' | translate}}</button>
      <button mat-menu-item [routerLink]="[splatsLink]">{{'SPLATS情報' | translate}}</button>
    </mat-menu>


    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId"
      [matMenuTriggerFor]="facility">{{'施設' | translate}}</button>
    <mat-menu #facility="matMenu">
      <button mat-menu-item [routerLink]="[facilityLink]">{{'施設情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[hallLink]">{{'建物・カテゴリ情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[floorLink]">{{'フロア・表示グループ情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[facilityUserLink]">{{'施設職員情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[purchaseContentDailyLink]">{{'コンテンツ購入日次情報' | translate}}</button>
    </mat-menu>

    <button mat-button *ngIf="!!isSignIn && !!projectId" [matMenuTriggerFor]="exhibit">{{'展示' |
      translate}}</button>
    <mat-menu #exhibit="matMenu">
      <button mat-menu-item [routerLink]="[exhibitLink]">{{ '展示情報' | translate }}</button>
      <button mat-menu-item [routerLink]="[exhibitDetailLink]">{{ '展示詳細情報' | translate }}</button>
      <button *ngIf="userType !== USER_TYPE_USER" mat-menu-item [routerLink]="[exhibitRankingLink]">{{ 'ランキング' | translate }}</button>
      <button mat-menu-item [routerLink]="[voiceFileDownloadLink]">{{ '音声ファイルダウンロード' | translate }}</button>
    </mat-menu>

    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId"
      [matMenuTriggerFor]="reservationFacility">{{'予約' | translate}}</button>
    <mat-menu #reservationFacility="matMenu">
      <button mat-menu-item [routerLink]="[reservationFacilityLink]">{{'予約施設情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[reservationQuestionLink]">{{'予約設問' | translate}}</button>
      <button mat-menu-item [routerLink]="[reservationLink]">{{'予約状況' | translate}}</button>
      <button mat-menu-item [routerLink]="[reservationDownloadLink]">{{'予約状況ダウンロード' | translate}}</button>
    </mat-menu>

    <button mat-button *ngIf="!!isSignIn && !!projectId" [matMenuTriggerFor]="master">{{'属性' |
      translate}}</button>
    <mat-menu #master="matMenu">
      <button *ngIf="userType !== USER_TYPE_USER" mat-menu-item [routerLink]="[facilityAttributeLink]">{{'施設属性情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[exhibitAttributeLink]">{{'展示属性情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[exhibitDetailAttributeLink]">{{'展示詳細属性情報' | translate}}</button>
      <button *ngIf="userType !== USER_TYPE_USER" mat-menu-item
        [routerLink]="[reservationFacilityAttributeLink]">{{'予約施設属性情報' | translate}}</button>
      <button *ngIf="userType !== USER_TYPE_USER" mat-menu-item
        [routerLink]="[uploadedFilesAttributeLink]">{{'アップロードファイル属性情報' | translate}}</button>
    </mat-menu>
    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId"
      [routerLink]="[qrcodeLink]">{{'QR(URL)生成' | translate}}</button>

    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId"
      [matMenuTriggerFor]="enquete">{{'アンケート' | translate}}</button>
    <mat-menu #enquete="matMenu">
      <button mat-menu-item [routerLink]="[questionLink]">{{'設問情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[questSetLink]">{{'設問セット' | translate}}</button>
      <button mat-menu-item [routerLink]="[enqueteLink]">{{'アンケート結果ダウンロード' | translate}}</button>
    </mat-menu>

    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId"
      [matMenuTriggerFor]="entranceExitManager">{{'入退場管理' | translate}}</button>
    <mat-menu #entranceExitManager="matMenu">
      <button mat-menu-item [routerLink]="[entranceExitEventLink]">{{'イベント情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[entranceExitQuestionLink]">{{'イベント設問' | translate}}</button>
      <button mat-menu-item [routerLink]="[entranceExitUserLink]">{{'スタッフ情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[entranceExitEntryLink]">{{'エントリー情報' | translate}}</button>
      <button mat-menu-item [routerLink]="[entranceExitTransitDailyLink]">{{'日次入退場状況' | translate}}</button>
    </mat-menu>

    <button mat-button *ngIf="!!isSignIn && userType === USER_TYPE_USER && !!projectId"
      [matMenuTriggerFor]="entranceExitUser">{{'入退場管理' | translate}}</button>
    <mat-menu #entranceExitUser="matMenu">
      <button mat-menu-item (click)="copyClipboardQrreaderUrl()">{{'QRリーダーサイトURLコピー' | translate}}</button>
      <button mat-menu-item [routerLink]="[entranceExitExhibitTransitDownloadLink]">{{'展示来場状況ダウンロード' |
        translate}}</button>
    </mat-menu>

    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId"
      [routerLink]="[shelterLink]">{{'避難所' | translate}}</button>

  </div>

  <!-- <button *ngIf="!!isSignIn && !projectId" (click)="switchLanguage(currentLanguage === 'en' ? 'ja' : 'en')">
    {{ currentLanguage === 'en' ? 'Japanese' : '英語' }}
  </button> -->

  <span class="space2" fxFlex="1 1 auto"></span>
  <div class="header-button">
    <button mat-button *ngIf="!!isSignIn" [routerLink]="[manualLink]" style="padding: 0 14px;">
      <mat-icon>help</mat-icon>
      {{'使い方' | translate}}
    </button>
    <button mat-button *ngIf="!!isSignIn && userType !== USER_TYPE_USER && !!projectId" [routerLink]="[noticeLink]" style="padding: 0 14px;">
      <mat-icon *ngIf="newNotices" class="material-icons color_gold">new_releases</mat-icon>
      {{'通知' | translate}}
    </button>

    <button mat-flat-button *ngIf="!!isSignIn" (click)="signOut()" [style.width.px]="102">{{'ログアウト' | translate}}</button>
  </div>
</mat-toolbar>